/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this._inited = false;

      // bind once
      this._onClickRemove = this.handleClick.bind(this);
      this._onClickQty = this.handleQtyButtons.bind(this);
      this._onChange = debounce(this.handleChange.bind(this));
    }

    connectedCallback() {
      if (this._inited) return;
      this._inited = true;
      this.init();
    }

    disconnectedCallback() {
      // optional cleanup (doesn't hurt)
      this.removeEventListener('click', this._onClickRemove);
      this.removeEventListener('click', this._onClickQty);
      this.removeEventListener('change', this._onChange);
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');

      // safe even if empty
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + (parseInt(quantityInput.value, 10) || 0),
        0
      );

      this.currentQuantities = {};
      this.querySelectorAll('.cart-item').forEach((item) => {
        const input = item.querySelector('.qty-input__input');
        const key = this.getItemKeyFromRow(item);
        if (!key) return;
        this.currentQuantities[key] = Number(input ? input.value : 0);
      });

      // listeners always attached (even when empty)
      this.addEventListener('click', this._onClickRemove);
      this.addEventListener('click', this._onClickQty);
      this.addEventListener('change', this._onChange);
    }

    // ===== helpers =====
    getItemKeyFromRow(row) {
  if (!row) return null;

  const lineKey = row.dataset.lineKey || row.dataset.key || row.getAttribute('data-line-key');
  if (lineKey) return lineKey;

  const idx = row.dataset.index || row.getAttribute('data-index');
  if (idx) return `line:${idx}`;

  const m = (row.id || '').match(/^cart-item-(\d+)$/);
  if (m) return `line:${m[1]}`;

  const vid = row.dataset.variantId || row.getAttribute('data-variant-id');
  return vid ? `variant:${vid}` : null;
}

    shouldStopPropagation(evt) {
  if (window.__BB_STOP_PROPAGATION__ === true) return true;
  const drawer = evt?.target?.closest?.('#cart-drawer');
  if (!drawer) return false;
  const flag = drawer.dataset && drawer.dataset.stopPropagation;
  return flag === 'true' || flag === '1';
}

    getLineFromTarget(target) {
  const row = target?.closest?.('.cart-item');
  if (!row) return null;

  const idx = Number(row.dataset.index || row.getAttribute('data-index'));
  if (idx) return idx;

  const m = (row.id || '').match(/^cart-item-(\d+)$/);
  return m ? parseInt(m[1], 10) : null;
}



    getQtyInputFromTarget(target) {
      const row = target && target.closest ? target.closest('.cart-item') : null;
      if (!row) return null;
      return row.querySelector('.qty-input__input');
    }

    // ===== events =====

    /**
     * Handles 'click' events on the cart items element.
     * Remove button only.
     */
    handleClick(evt) {
  const removeBtn = evt.target.closest ? evt.target.closest('.js-remove-item') : null;
  if (!removeBtn) return;

  // ⛔ BLOCK APP LISTENERS (CRITICAL)
  evt.preventDefault();
  if (this.shouldStopPropagation(evt)) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
  }

  const line = this.getLineFromTarget(removeBtn) || Number(removeBtn.dataset.index);
  if (!line) return;

  this.updateQuantity(line, 0);
}


    /**
     * Handles 'change' events on the cart items element.
     */
    handleChange(evt) {
  if (this.shouldStopPropagation(evt)) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
  }

  const line = this.getLineFromTarget(evt.target) || Number(evt.target.dataset.index);
  if (!line) return;

  const qty = evt.target.value;
  this.updateQuantity(line, qty, document.activeElement && document.activeElement.name);
}


    /**
     * Handles +/- clicks in drawer
     */
    handleQtyButtons(evt) {
      // ignore remove
      if (evt.target.closest && evt.target.closest('.js-remove-item')) return;

      // react only if click happened inside quantity-input component
      const qi = evt.target.closest ? evt.target.closest('quantity-input') : null;
      if (!qi) return;

        // ⛔ BLOCK APP LISTENERS
  if (this.shouldStopPropagation(evt)) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
  }


      const line = this.getLineFromTarget(evt.target);
      if (!line) return;
      

      // Wait for the component to update the input value
      setTimeout(() => {
        const input = this.getQtyInputFromTarget(evt.target);
        if (!input) return;

        const qty = input.value;
        this.updateQuantity(line, qty, input.name || 'updates[]');
      }, 0);
    }

    /**
     * Updates the quantity of a line item.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = lineItem ? Number(lineItem.dataset.variantId) : null;
        const itemKey = lineItem ? this.getItemKeyFromRow(lineItem) : `line:${line}`;
        const oldTotalQuantity = this.currentTotalItemCount;

        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          if (cartDrawerContent) {
            cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);
          }

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // Cart page
          const cartTitle = this.closest('.cc-main-cart')?.querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartContent = document.getElementById('cart-summary-and-blocks');
          if (cartContent) cartContent.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        if (this.cartDrawer && newTotalQuantity === 0 && cartDrawerContent) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);

        this.dataset.empty = String(newTotalQuantity === 0);
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity && variantId != null) {
          const oldQuantity = (itemKey && this.currentQuantities[itemKey] != null)
            ? this.currentQuantities[itemKey]
            : 0;
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity,
              newQuantity: Number(quantity)
            }
          }));
        }

        if (itemKey) this.currentQuantities[itemKey] = Number(quantity);

        if (lineErrors) {
          lineErrors.innerHTML = '';
          lineErrors.hidden = true;
        }
      } catch (error) {
        const lineErrorsId = `line-item-error-${line}`;
        const lineErrors = document.getElementById(lineErrorsId);

        if (lineErrors) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrors.textContent = theme.strings.cartError;
          } else {
            lineErrors.textContent = error.message;
          }
          lineErrors.hidden = false;
        }

        // eslint-disable-next-line no-console
        console.log(error);

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: error.message }
        }));

        const input = document.getElementById(`quantity-${line}`);
        if (input) {
          input.value = input.dataset.initialValue;
          const qi = input.closest('quantity-input');
          if (qi) qi.currentQty = input.dataset.initialValue;
        }
      } finally {
        this.classList.remove('pointer-events-none');

        // keep scroll position in drawer
        if (cartDrawerContent && this.cartDrawer) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        if (errors) {
          errors.innerHTML = '';
          errors.hidden = true;
        }
      } catch (error) {
        if (errors) {
          errors.textContent = theme.strings.cartError;
          errors.hidden = false;
        }

        // eslint-disable-next-line no-console
        console.log(error);

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: error.message }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        { id: 'free-shipping-notice', section: 'free-shipping-notice', selector: '.free-shipping-notice' }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          { id: 'cart-items', section: cartDrawerId, selector: 'cart-items' },
          { id: 'cart-promoted-products', section: cartDrawerId, selector: '#cart-promoted-products' },
          { id: 'cart-drawer', section: cartDrawerId, selector: '.cart-drawer__summary' },
          { id: 'cart-drawer-media-promotion', section: cartDrawerId, selector: '#cart-drawer-media-promotion' }
        ];
      } else {
        sections = [
          ...sections,
          { id: 'cart-items', section: this.dataset.section, selector: 'cart-items' },
          { id: 'cart-summary', section: document.getElementById('cart-summary').dataset.section, selector: '.cart__summary' }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      if (document.activeElement) document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      if (!cartStatus) return;

      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(this.cartDrawer.querySelector('.js-cart-empty'), this.cartDrawer.querySelector('a'));
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
